import * as React from 'react';
import Container from '@boschebike/ebds-react/dist-esm/components/Container.js';
import { UpdateFeed } from '@boschebike/ebds-react/dist-esm/components/UpdateFeed.js';

/**
 * @typedef {import('../../App.d.ts').UpdateFeedProps} UpdateFeedProps
 */
/**
 * @param {UpdateFeedProps} props
 */
export default (props) => {
  return (
    <Container>
      <UpdateFeed
        data-testid="update-feed"
        {...props}
      >
        {props.children}
      </UpdateFeed>
    </Container>
  );
};
